import { useTranslation } from "react-i18next";
import { useKycFormOpen } from "@features/KnowYourCustomerNotification/utils";
import { Button } from "@components/Button";
import { parseHtml } from "@components/HTMLParser/utils";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";

export const KYCWarningModal: React.FC<IUseModalProps> = (props) => {
  const modal = useModal(props);
  const { t } = useTranslation();
  const { isPrefetching, open: openKycForm } = useKycFormOpen();

  const open = async () => {
    await openKycForm();
    modal.close();
  };

  return (
    <Modal
      modal={modal}
      title={t("KYCWarningModal.title")}
      actionButtons={
        <>
          <Button className="w-full" variant="secondary" onClick={modal.close}>
            {t("KYCWarningModal.buttons.cancel")}
          </Button>
          <Button className="w-full" isLoading={isPrefetching} onClick={open}>
            {t("KYCWarningModal.buttons.submit")}
          </Button>
        </>
      }
    >
      <p>{parseHtml(t("KYCWarningModal.description"))}</p>
    </Modal>
  );
};
